<div id="ht">
    <div id="main-cnt">

        <ion-header class="main-header block">
            <ion-toolbar class="blues-nav">
              <ion-buttons slot="start" class="nav-content">
                <div size="2" class="nav-back">
                  <span class="custom-icon-back-arrow-icon" (click)="back()">
                    <span class="path1"></span>
                    <span class="path2"></span>
                  </span>
                  <span *ngIf="project === 'overview'" class="breadcrumb">MIA SQUADRA - OVERVIEW</span>
                    <span *ngIf="project === 'summary'" class="breadcrumb">MIA SQUADRA - BONUS</span>
                </div>
              </ion-buttons>
              <div slot="end" class="notification-div">
                    <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">


                    </ion-avatar>
                </div>
            </ion-toolbar>
            <br>

            <!-- edit da qui... -->
            <div class="glass-blurred-background panel-buttons-container">
                <div class="panel-button theme-text-color" [class.active]="currentPanel == 'overview'" (click)="currentPanel = 'overview'">
                    <div class="panel-button-image-container">
                    <img class="panel-button-image svg-white" src="./assets/imgs/overview.svg">
                    </div>
                    <h4>Overview</h4>
                </div>
                <div class="panel-button theme-text-color" [class.active]="currentPanel == 'bonus'" (click)="currentPanel = 'bonus'">
                    <div class="panel-button-image-container">
                    <img class="panel-button-image svg-white" src="./assets/imgs/report.svg">
                    </div>
                    <h4>Bonus</h4>
                </div>
            </div>

			<!-- @tmp -->
			<div style="text-align:right;padding:0 1.5rem;">
				<span style="font-size:2rem; background:orange; border-radius:50%;" class="hidden custom-icon-edit-icon" (click)="editTeam()"></span>
			</div>
            <!-- ...a qui -->
        </ion-header>


        <ion-content class="main-content">
            <div class="scroller-container">
                <div class="content-scroller">
                    <div class="content with-floating-footer">
                        <!-- edit da qui... -->

                        <div class="flex-panel" *ngIf="currentPanel == 'overview'">
							
							
							<div class="glass-blurred-background padding full-width text-bold">
								<div class="flex-row">
									<div class="flex-left">
										Description
										<br>
										{{ currentTeam?.description }}...
									</div>
								</div>								
							</div>

							<br>

							<div class="glass-blurred-background padding full-width text-bold">
								<div class="flex-row">
									<div class="flex-left">Managed by</div>
								</div>
								<div class="flex-row">
									<div class="flex-grid-3 text-center">
									  <div (click)="openUserProfile(currentTeam?.manager.id)" class="tiny-card center-content glass-blurred-background drop-shadow" *ngIf="currentTeam?.manager">                                            
										  <img class="space-below svg-white list-avatar" src="./assets/imgs/avatar.svg">
										  <div class="user-name">{{ currentTeam?.manager.name|titlecase }} {{ currentTeam?.manager.lastname |titlecase}}</div>
									  </div>
									</div>  
								</div>
							</div>

							<br>

							<div class="glass-blurred-background padding full-width text-bold">
								<div class="flex-row">
									<div class="flex-left">Members count: {{ teammates?.length }}</div>
								</div>								
							</div>

							<br>

							<div class="glass-blurred-background padding full-width text-bold">
								<div class="flex-row">
									<div class="flex-left">Team</div>
								</div>
								<div class="flex-row">
									<div class="flex-grid-3">
										<div (click)="openUserProfile(m.id)" class="tiny-card member center-content glass-blurred-background drop-shadow" *ngFor="let m of teammates">                                            
											<img class="space-below svg-white list-avatar" src="./assets/imgs/avatar.svg">
											<div class="user-name">{{ m.name |titlecase}} {{ m.lastname |titlecase}}</div>
										</div>
									</div>  
								</div>
							</div>

                        </div>


                        <div class="flex-panel" *ngIf="currentPanel == 'bonus'">
                            <div class="flex-tabs">
                                <div class="flex-tab glass-blurred-background drop-shadow padding" [class.active]="period == 'mese'" (click)="period = 'mese'">
                                  Mensile
                                </div>
                                <div class="flex-tab glass-blurred-background drop-shadow padding" [class.active]="period == 'anno'" (click)="period = 'anno'">
                                  Annuale
                                </div>
                            </div>
    
                            <br>

                            <div *ngIf="period == 'mese'">
                                <div class="glass-blurred-background padding full-width text-bold">
    
                                    <div class="flex-collapsible">
                                      <div class="flex-row header" (click)="showTotalRevenuePanel = !showTotalRevenuePanel">
                                        <div class="flex-left">
                                            <div>
                                                <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg" *ngIf="showTotalRevenuePanel">
                                                <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg" *ngIf="!showTotalRevenuePanel">
                                                Fatturato tot team
                                            </div>
                                        </div>
                                        <div class="flex-right">
                                          <div><span style="margin-right:40px;">{{ teammates.length }}</span> {{ teamTotSales | currency:'EUR' }}</div>
                                        </div>
                                      </div>
        
                                      <div class="panel" *ngIf="showTotalRevenuePanel">
                                        <div class="flex-row">
                                          <div class="flex-grid-3">

                                            <div (click)="openUserProfile(m.id)" class="tiny-card center-content glass-blurred-background drop-shadow" *ngFor="let m of teammates">                                            
                                                <img class="space-below svg-white list-avatar" src="./assets/imgs/avatar.svg">
                                                <div>€ 5.000</div>
                                                <div class="ellipsis">{{ m.name?.slice(0, 1) }}. {{ m.lastname |titlecase}}</div>
                                            </div>
                                          </div>
        
                                        </div>
                                      </div>
                                    </div>
        
                                </div>
        
                                <br>
        
                                <div class="glass-blurred-background padding full-width text-bold">
        
                                    <div class="flex-collapsible">
                                      <div class="flex-row header" (click)="showBonusMembersPanel = !showBonusMembersPanel">
                                        <div class="flex-left wide">        
                                          <div>
                                            <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg" *ngIf="showBonusMembersPanel">
                                            <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg" *ngIf="!showBonusMembersPanel">
                                              Membri candidati al Team Bonus
                                            </div>
                                        </div>

                                        <div class="flex-right">
                                            {{ membersForBonus.length }}
                                        </div>
                                      </div>
        
                                      <div class="panel" *ngIf="showBonusMembersPanel">
                                        <div class="flex-row">
                                          <div class="flex-grid-4">
                                            <div (click)="openUserProfile(m.id)" class="tiny-card center-content glass-blurred-background drop-shadow" *ngFor="let m of membersForBonus">                                            
                                                <img class="space-below svg-white list-avatar" src="./assets/imgs/avatar.svg">
                                                <div>€ 5.000</div>
                                                <div class="ellipsis">{{ m.name?.slice(0, 1) }}. {{ m.lastname  |titlecase}}</div>
                                            </div>
                                          </div>
        
                                        </div>
        
        
                                        <div class="flex-row">
                                          <div class="flex-left">Livello attuale</div>
                                        </div>
        
                                        <div class="glass-blurred-background drop-shadow padding">
        
                                            <div class="flex-row">
                                              <div class="flex-left">
                                                <div>Volume</div>
                                              </div>
                                              <div class="flex-right">
                                                <div>Bonus</div>
                                              </div>
                                            </div>
                                            <div class="flex-row volume-level">
                                              <div class="flex-left">
                                                <div>N. membri*€ 10.000</div>
                                              </div>
                                              <div class="flex-right">
                                                <div>0,50%</div>
                                              </div>
                                            </div>
                                            <div class="flex-row volume-level">
                                              <div class="flex-left">
                                                <div>N. membri*€ 20.000</div>
                                              </div>
                                              <div class="flex-right">
                                                <div>1,00%</div>
                                              </div>
                                            </div>
                                            <div class="flex-row volume-level active">
                                              <div class="flex-left">
                                                <div>N. membri*€ 30.000</div>
                                              </div>
                                              <div class="flex-right">
                                                <div>1,50%</div>
                                              </div>
                                            </div>
        
                                          </div>
        
                                      </div>
                                    </div>
        
                                </div>
                            </div>

                            <div *ngIf="period == 'anno'">
                                <div class="glass-blurred-background padding full-width text-bold">
        
                                    <div class="flex-collapsible">
                                      <div class="flex-row header" (click)="showCompanyBonusPanel = !showCompanyBonusPanel">
                                        <div class="flex-left wide">
                                          <div>
                                            <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg" *ngIf="showCompanyBonusPanel">
                                            <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg" *ngIf="!showCompanyBonusPanel">
                                              Company Bonus Annuale
                                            </div>
                                        </div>
                                        <div class="flex-right">
                                            @progress
                                        </div>
                                      </div>
        
                                        <div class="panel" *ngIf="showCompanyBonusPanel">
                                            <div class="glass-blurred-background drop-shadow padding">
        
                                                <div class="flex-row">
                                                  <div class="flex-left">
                                                    <div>Volume</div>
                                                  </div>
                                                  <div class="flex-right">
                                                    <div>Bonus</div>
                                                  </div>
                                                </div>

                                                <div class="flex-row volume-level">
                                                  <div class="flex-left">
                                                    <div>€ 1.000.000</div>
                                                  </div>
                                                  <div class="flex-right">
                                                    <div>0,50%</div>
                                                  </div>
                                                </div>
                                                <div class="flex-row volume-level">
                                                  <div class="flex-left">
                                                    <div>€ 2.000.000</div>
                                                  </div>
                                                  <div class="flex-right">
                                                    <div>0,75%</div>
                                                  </div>
                                                </div>
                                                <div class="flex-row volume-level">
                                                  <div class="flex-left">
                                                    <div>€ 3.000.000</div>
                                                  </div>
                                                  <div class="flex-right">
                                                    <div>1,00%</div>
                                                  </div>
                                                </div>
                                                <div class="flex-row volume-level">
                                                  <div class="flex-left">
                                                    <div>€ 4.000.000</div>
                                                  </div>
                                                  <div class="flex-right">
                                                    <div>1,25%</div>
                                                  </div>
                                                </div>
                                                <div class="flex-row volume-level">
                                                  <div class="flex-left">
                                                    <div>€ 5.000.000</div>
                                                  </div>
                                                  <div class="flex-right">
                                                    <div>1,50%</div>
                                                  </div>
                                                </div>
                                                         
                                            </div> 
                                      </div>

                                    </div>
                                </div>

                                <br> 
                                
                                <div class="glass-blurred-background padding full-width text-bold">

                                    <div class="flex-collapsible">
                                        <div class="flex-row header" (click)="showDirectorBonusPanel = !showDirectorBonusPanel">
                                          <div class="flex-left wide">
                                            <div>
                                              <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-down.svg" *ngIf="showDirectorBonusPanel">
                                              <img class="svg-white vertical-middle xsmall" src="./assets/imgs/caret-right.svg" *ngIf="!showDirectorBonusPanel">
                                                Director Bonus
                                              </div>
                                          </div>
                                          <div class="flex-right">
                                              @progress
                                          </div>
                                        </div>
          
                                          <div class="panel" *ngIf="showDirectorBonusPanel">
                                              <div class="glass-blurred-background drop-shadow padding">
          
                                                  <div class="flex-row">
                                                    <div class="flex-left">
                                                      <div>Volume</div>
                                                    </div>
                                                    <div class="flex-right">
                                                      <div>Bonus</div>
                                                    </div>
                                                  </div>
  
                                                  <div class="flex-row volume-level">
                                                    <div class="flex-left">
                                                      <div>€ 1.000.000</div>
                                                    </div>
                                                    <div class="flex-right">
                                                      <div>0,20%</div>
                                                    </div>
                                                  </div>
                                                  <div class="flex-row volume-level">
                                                    <div class="flex-left">
                                                      <div>€ 2.000.000</div>
                                                    </div>
                                                    <div class="flex-right">
                                                      <div>0,40%</div>
                                                    </div>
                                                  </div>
                                                  <div class="flex-row volume-level">
                                                    <div class="flex-left">
                                                      <div>€ 3.000.000</div>
                                                    </div>
                                                    <div class="flex-right">
                                                      <div>0,60%</div>
                                                    </div>
                                                  </div>
                                                  <div class="flex-row volume-level">
                                                    <div class="flex-left">
                                                      <div>€ 4.000.000</div>
                                                    </div>
                                                    <div class="flex-right">
                                                      <div>0,80%</div>
                                                    </div>
                                                  </div>
                                                  <div class="flex-row volume-level">
                                                    <div class="flex-left">
                                                      <div>€ 5.000.000</div>
                                                    </div>
                                                    <div class="flex-right">
                                                      <div>1,00%</div>
                                                    </div>
                                                  </div>
                                                           
                                              </div> 
                                        </div>
  
                                      </div>
        
                                </div>
                            </div>
    
                        </div>
                        
                        <div class="floating-footer center-content">                            
                          <div class="flex-left text-center">Tot bonus {{ period }}</div>
                          <div class="flex-right text-center">€ {{ bonusByPeriod }}</div>
                        </div>
                        <!-- ...a qui -->
                    </div>
                </div>
            </div>
        </ion-content>

    </div>
  </div>
